// extracted by mini-css-extract-plugin
export var authorContainer = "moreReading-module--authorContainer--xNfFQ";
export var bigCardContainer = "moreReading-module--bigCardContainer--nERrB";
export var bigReadingCard = "moreReading-module--bigReadingCard--NUhmZ";
export var body = "moreReading-module--body--5KBDK";
export var buttonLink = "moreReading-module--buttonLink--AnzqM";
export var description = "moreReading-module--description--Nb3QG";
export var fullWidth = "moreReading-module--fullWidth--qG0H1";
export var hover = "moreReading-module--hover--aGx2H";
export var hoverContentContainer = "moreReading-module--hoverContentContainer--34npt";
export var imageContainer = "moreReading-module--imageContainer--VNwNf";
export var label = "moreReading-module--label--8+Ooq";
export var leftContainer = "moreReading-module--leftContainer--cQ2mi";
export var limited = "moreReading-module--limited--lB-rZ";
export var linkContainer = "moreReading-module--linkContainer--RXHUH";
export var list = "moreReading-module--list--Q0kgi";
export var mediumReadingCard = "moreReading-module--mediumReadingCard--0AjZF";
export var middleContainer = "moreReading-module--middleContainer--4po61";
export var moreReading = "moreReading-module--moreReading--eUe9y";
export var quoteText = "moreReading-module--quoteText--zvc5l";
export var rightContainer = "moreReading-module--rightContainer--fgkio";
export var sbShowMain = "moreReading-module--sb-show-main--M+9bx";
export var smallReadingCard = "moreReading-module--smallReadingCard--WmkyU";
export var storybook = "moreReading-module--storybook--gIhGl";
export var subtitle = "moreReading-module--subtitle--XDDIf";
export var withButton = "moreReading-module--withButton--S5u1s";
export var withDesc = "moreReading-module--withDesc--hNtgG";